/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section6_P2Inputs */

const en_about_section6_p2 = /** @type {(inputs: About_Section6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I take that responsibility seriously. The tools are kept up to date, the client-side promise is never quietly broken, and I answer the messages I get. The Contact page has my email and a link to the GitHub repository, where the full source is open for anyone to inspect and verify that nothing is uploaded.`)
};

const ko_about_section6_p2 = /** @type {(inputs: About_Section6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 책임을 가볍게 여기지 않습니다. 도구는 계속 최신 상태로 유지하고, 클라이언트 사이드 처리 약속을 조용히 어기지 않으며, 받은 메일에는 답합니다. 문의 페이지에 제 이메일과 GitHub 저장소 링크가 있습니다. 저장소에는 전체 소스가 공개되어 있어 아무것도 업로드되지 않는다는 점을 누구나 직접 확인할 수 있습니다.`)
};

const ja_about_section6_p2 = /** @type {(inputs: About_Section6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その責任を軽く考えてはいません。ツールは最新の状態に保ち、クライアントサイド処理の約束を黙って破ることはせず、届いたメールには返信します。お問い合わせページに私のメールアドレスと GitHub リポジトリのリンクがあります。リポジトリには全ソースが公開されており、何もアップロードされていないことを誰でも自分で確認できます。`)
};

/**
* | output |
* | --- |
* | "I take that responsibility seriously. The tools are kept up to date, the client-side promise is never quietly broken, and I answer the messages I get. The Co..." |
*
* @param {About_Section6_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section6_p2 = /** @type {((inputs?: About_Section6_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section6_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section6_p2(inputs)
	if (locale === "ko") return ko_about_section6_p2(inputs)
	return ja_about_section6_p2(inputs)
});